import { InputField, MandatoryFieldsMarker } from '@dtk/ui-components';

export const PlanerConsultingForm = () => {
  return (
    <>
      <div className="col-span-6">
        <InputField id="zipCode" name="zipCode" label="Ihre Postleitzahl" type="text" isMandatory />
      </div>
      <MandatoryFieldsMarker />
    </>
  );
};
